/* eslint-disable react/jsx-no-target-blank */
import React, { useContext, useEffect } from 'react'
// import {useIntl} from 'react-intl'
import { checkIsActive, KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
// import { IsAuthorizedContext } from '../../../../app/contexts/isAuthorizedContext';
import { useAuth } from '../../../../app/contexts/CustomContextHook/useAuth';
import { useHotel } from '../../../../app/contexts/CustomContextHook/useHotel'
import { useHotel2 } from '../../../../app/contexts/HotelContext';
import { useHistory, useLocation } from 'react-router-dom';
import { useLayout } from '../../core';
import clsx from 'clsx';

export function AsideMenuMain() {
  // const intl = useIntl()

  // const isAuthorizedCxt = useContext(IsAuthorizedContext);

  const { UserToken, setUserToken } = useAuth('')


  const history = useHistory();
  // const { Hotel, setHotel } = useHotel()

  const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2();

  let IsAdmin = false;

  let IsManager = false;


  let IsCheifEngineer = false;

  let IsVPO = false;

  let IsAreaDirector = false;

  if (UserToken.Roles.length !== 0) {
    UserToken.Roles.forEach(role => {
      if (role.toLowerCase().includes('admin')) {
        IsAdmin = true;
      } else if (role.toLowerCase().includes('general') && role.toLowerCase().includes('manager')) {
        IsManager = true;

      } else if (role.toLowerCase().includes('chief') && role.toLowerCase().includes('engineer')) {
        IsCheifEngineer = true;

      } else if (role.toLowerCase().includes('vp') || role.toLowerCase().includes('vpo')) {
        IsVPO = true;
      }
      else if (role.toLowerCase().includes('area') && role.toLowerCase().includes('director')) {
        IsAreaDirector = true;
      }
    });
  }




  const logout = () => {
    // localStorage.setItem('isAuthorized', 'false');
    // isAuthorizedCxt.setIsaAuthorized(false);

    // localStorage.setItem('HotelId', 0);

    // setHotel({ HotelId: 0 });

    setHotelId('0');
    setHotelName("");


    // localStorage.setItem('Token', '');

    // localStorage.setItem('Expiry', '');



    // localStorage.setItem('LoggedInUserId', '');
    // localStorage.setItem('UserRoles', []);

    // localStorage.setItem('FirstName', '');
    // localStorage.setItem('LastName', '');
    // localStorage.setItem('Email', '');

    localStorage.setItem("SignOut", true);

    localStorage.removeItem("WeeklyWrapUpObj");
    localStorage.removeItem("WeeklyWrapUpObjEditedHotelId");
    localStorage.removeItem('ReturnURL');
    localStorage.removeItem('FormEditingMode');
    localStorage.removeItem('IsEditOperation');


    localStorage.removeItem('PayrollReportObjEditedHotelId');
    localStorage.removeItem('PayrollReportObjFormEditingMode');
    localStorage.removeItem('IsPayrollReportObjEditOperation');
    localStorage.removeItem('PayrollReportReturnURL');
    localStorage.removeItem('PayrollReportObj');


    setUserToken('', '', '', [], '', '', '');


  }

  const handleWeeklyWrapUpClick = () => {

    console.log('onClick Triggering --**');

    if (localStorage.getItem("WeeklyWrapUpObj") !== null) {

      let EditedHotelId = localStorage.getItem("WeeklyWrapUpObjEditedHotelId");

      console.log('EditedHotelId == ', EditedHotelId);

      console.log('HotelId == ', HotelId);

      let Result = HotelId == EditedHotelId;

      console.log('HotelId == EditedHotelId ** ', Result);

      if (Result == false) {

        console.log('$$##@@!!!%%^^^&&&(())');

        localStorage.removeItem("WeeklyWrapUpObj");

        localStorage.removeItem("WeeklyWrapUpObjEditedHotelId");

        localStorage.removeItem('ReturnURL');

        localStorage.removeItem('FormEditingMode');

        localStorage.removeItem('IsEditOperation');


      }

    }


    let FormEditingMode = localStorage.getItem("FormEditingMode");

    let IsEditOperation = localStorage.getItem('IsEditOperation');

    let ReturnURL = localStorage.getItem('ReturnURL');


    console.log('FormEditingMode == ', FormEditingMode);
    if (FormEditingMode && IsEditOperation && ReturnURL) {
      history.push(ReturnURL);
      console.log('In if Statement AsideMenuMain FormEditingMode && IsEditOperation && ReturnURL');

    }
    else if (FormEditingMode) {

      history.push('/weeklyWrapUp/create');

      console.log('In if Statement AsideMenuMain only FormEditingMode');

    }

    else {

      console.log('In else-if Statement AsideMenuMain');

      history.push('/weeklyWrapUp/All-reports');
    }
  }

  const handlePayrollReportClick = () => {

    console.log('onClick Triggering --**');

    if (localStorage.getItem("PayrollReportObj") !== null) {

      let EditedHotelId = localStorage.getItem("PayrollReportObjEditedHotelId");

      let Result = HotelId == EditedHotelId;

      console.log('HotelId == EditedHotelId ** ', Result);

      if (Result == false) {

        console.log('$$##@@!!!%%^^^&&&(())');

        localStorage.removeItem('PayrollReportObjEditedHotelId');
        localStorage.removeItem('PayrollReportObjFormEditingMode');
        localStorage.removeItem('IsPayrollReportObjEditOperation');
        localStorage.removeItem('PayrollReportReturnURL');
        localStorage.removeItem('PayrollReportObj');
      }
    }
    let FormEditingMode = localStorage.getItem("PayrollReportObjFormEditingMode");

    let IsEditOperation = localStorage.getItem('IsPayrollReportObjEditOperation');

    let ReturnURL = localStorage.getItem('PayrollReportReturnURL');

    if (FormEditingMode && IsEditOperation && ReturnURL) {
      history.push(ReturnURL);
    }
    else if (FormEditingMode) {
      history.push('/payrollReport/create');
    }
    else {
      history.push('/payrollReport/AllpayrollReports');
    }
  }



  const handleDocumentLibraryClick = () => {

    console.log('onClick Triggering --**');

    if (localStorage.getItem("DocumentLibraryObj") !== null) {

      let EditedHotelId = localStorage.getItem("DocumentLibraryObjEditedHotelId");

      let Result = HotelId == EditedHotelId;

      console.log('HotelId == EditedHotelId ** ', Result);

      if (Result == false) {

        console.log('$$##@@!!!%%^^^&&&(())');

        localStorage.removeItem('DocumentLibraryObjEditedHotelId');
        localStorage.removeItem('DocumentLibraryObjFormEditingMode');
        localStorage.removeItem('IsDocumentLibraryObjEditOperation');
        localStorage.removeItem('DocumentLibraryReturnURL');
        localStorage.removeItem('DocumentLibraryObj');
      }
    }
    let FormEditingMode = localStorage.getItem("DocumentLibraryObjFormEditingMode");

    let IsEditOperation = localStorage.getItem('IsDocumentLibraryObjEditOperation');

    let ReturnURL = localStorage.getItem('DocumentLibraryReturnURL');

    if (FormEditingMode && IsEditOperation && ReturnURL) {
      history.push(ReturnURL);
    }
    else if (FormEditingMode) {
      history.push('/documentLibrary/create');
    }
    else {
      history.push('/documentLibrary/All');
    }
  }



  const handleEOMLibraryClick = () => {

    console.log('onClick Triggering --**');

    if (localStorage.getItem("EOMLibraryObj") !== null) {

      let EditedHotelId = localStorage.getItem("EOMLibraryObjEditedHotelId");

      let Result = HotelId == EditedHotelId;

      console.log('HotelId == EditedHotelId ** ', Result);

      if (Result == false) {

        console.log('$$##@@!!!%%^^^&&&(())');

        localStorage.removeItem('EOMLibraryObjEditedHotelId');
        localStorage.removeItem('EOMLibraryObjFormEditingMode');
        localStorage.removeItem('IsEOMLibraryObjEditOperation');
        localStorage.removeItem('EOMLibraryReturnURL');
        localStorage.removeItem('EOMLibraryObj');
      }
    }
    let FormEditingMode = localStorage.getItem("EOMLibraryObjFormEditingMode");

    let IsEditOperation = localStorage.getItem('IsEOMLibraryObjEditOperation');

    let ReturnURL = localStorage.getItem('EOMLibraryReturnURL');

    if (FormEditingMode && IsEditOperation && ReturnURL) {
      history.push(ReturnURL);
    }
    else if (FormEditingMode) {
      history.push('/eomLibrary/create');
    }
    else {
      history.push('/eomLibrary/All');
    }
  }



  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, '/weeklyWrapUp')
  const { config } = useLayout()
  const { aside } = config



  const isActivePayrollReport = checkIsActive(pathname, '/payrollReport')
  const isActiveDocumentLibrary = checkIsActive(pathname, '/documentLibrary')
  const isActiveEOMLibrary = checkIsActive(pathname, '/eomLibrary')


  return (
    <>


      {IsAdmin && HotelId === '0' &&
        <>

          <AsideMenuItem
            to='/allHotels'
            icon='/media/icons/duotune/art/art002.svg'
            title={'All Hotels'}
            fontIcon='bi-app-indicator'
          />

          <AsideMenuItem
            to='/dashboard'
            icon='/media/icons/duotune/art/art006.svg'
            title={'Dashboard'}
            fontIcon='bi-app-indicator'
          />




          <AsideMenuItem
            to='/hotels'
            title='Manage Hotels'
            icon='/media/icons/duotune/general/gen019.svg'

          />


          <AsideMenuItemWithSub
            to='/users'
            title='Users'
            icon='/media/icons/duotune/general/gen025.svg'
            fontIcon='bi-layers'
          >

            <AsideMenuItem
              to='/roles/AllRoles'
              title='Manage Roles'
              icon='/media/icons/duotune/general/gen032.svg'

            />

            <AsideMenuItem
              to='/users/AllUsers'
              title='Manage Users'
              icon='/media/icons/duotune/general/gen033.svg'

            />
          </AsideMenuItemWithSub>


        </>
      }

      {!IsAdmin && HotelId === '0' &&
        <>
          <AsideMenuItem
            to='/allHotels'
            icon='/media/icons/duotune/art/art002.svg'
            title={'All Hotels'}
            fontIcon='bi-app-indicator'
          />

          {!IsManager &&
            <AsideMenuItem
              to='/dashboard'
              icon='/media/icons/duotune/art/art006.svg'
              title={'Dashboard'}
              fontIcon='bi-app-indicator'
            />
          }
        </>
      }

      {/* {!IsAdmin &&
        <>
          <AsideMenuItem
            to='/allHotels'
            icon='/media/icons/duotune/art/art002.svg'
            title={'All Hotels'}
            fontIcon='bi-app-indicator'

          />
        </>
      } */}

      {HotelId !== '0' &&



        <AsideMenuItem
          to='/allHotels'
          icon='/media/icons/duotune/art/art002.svg'
          title={'Admin'}
          fontIcon='bi-app-indicator'
        />

      }

      {!IsCheifEngineer && HotelId !== '0' && HotelId !== 0 &&

        <>

          <AsideMenuItem
            to='/hotels/hotelDashboard'
            icon='/media/icons/duotune/art/art004.svg'
            title={'Hotel Dashboard'}
            fontIcon='bi-app-indicator'
          />

          <AsideMenuItem
            to='/departments'
            icon='/media/icons/duotune/art/art009.svg'
            title={'Departments'}
            fontIcon='bi-app-indicator'
          />

          <AsideMenuItem
            to='/employees'
            icon='/media/icons/duotune/general/gen049.svg'
            title={'Employees'}
            fontIcon='bi-app-indicator'
          />

          {/* <AsideMenuItem
            to='/payrollReport'
            icon='/media/icons/duotune/art/art010.svg'
            title={'PayrollRoport'}
            fontIcon='bi-app-indicator'
          /> */}

          <div onClick={handlePayrollReportClick} className={`menu-item px-5 d-flex mb-2`} style={{ cursor: 'pointer' }}>
            <span className='menu-icon m-2'>
              <KTSVG path={'/media/icons/duotune/calendar/calendar3-dark.svg'} className='svg-icon-2' />
            </span>
            {'bi-app-indicator' && aside.menuIcon === 'font' &&
              <i className={clsx('bi fs-3 m-2', 'bi-app-indicator')}></i>}
            <a className={`m-2 menu-title fs-6 ${isActivePayrollReport ? 'text-light' : 'text-muted'}`}>
              Payroll Report
            </a>
          </div>


          <AsideMenuItemWithSub
            // to='/linenInventories'
            title='End of Month'
            icon='/media/icons/duotune/general/gen025.svg'
            fontIcon='bi-layers'
          >

            <AsideMenuItem
              to='/linenItems/AllLinenItems'
              icon='/media/icons/duotune/ecommerce/ecm007.svg'
              title={'Linen Items'}
              fontIcon='bi-app-indicator'
            />

            <AsideMenuItem
              to='/linenInventories'
              icon='/media/icons/duotune/art/art002.svg'
              title={'Linen Inventory'}
              fontIcon='bi-app-indicator'
            />

            {/* </AsideMenuItemWithSub> */}

            {/* <AsideMenuItemWithSub
            to='/sundriesShopInventories'
            title='SundriesShop Inventory'
            icon='/media/icons/duotune/general/gen028.svg'
            fontIcon='bi-layers'
          > */}
            <AsideMenuItem
              to='/sundriesShopProducts/AllProducts'
              icon='/media/icons/duotune/ecommerce/ecm001.svg'
              title={'Market Products'}
              fontIcon='bi-app-indicator'
            />

            <AsideMenuItem
              to='/sundriesShopInventories/AllSundriesShopInventories'
              icon='/media/icons/duotune/general/gen022.svg'
              title={'Market Inventory'}
              fontIcon='bi-app-indicator'
            />


            <div onClick={handleEOMLibraryClick} className={`menu-item menu-link px-5 d-flex pt-2`} style={{ cursor: 'pointer' }}>
              <span className='menu-icon m-2'>
                <KTSVG path={'/media/icons/duotune/files/fil009.svg'} className='svg-icon-2' />
              </span>
              {'bi-app-indicator' && aside.menuIcon === 'font' &&
                <i className={clsx('bi fs-3 ', 'bi-app-indicator')}></i>}
              <a className={` m-3 menu-title fs-6 ${isActiveEOMLibrary ? 'text-light' : 'text-muted'}`}
              // style={{marginLeft : '25px'}}
              >
                EOM Library
              </a>
            </div>

            <AsideMenuItem
              to='/selfQA'
              icon='/media/icons/duotune/general/gen022.svg'
              title={'Self QA'}
              fontIcon='bi-app-indicator'
            />


          </AsideMenuItemWithSub>



          <AsideMenuItemWithSub
            to='/BreakfastReport'
            title='Breakfast Report'
            icon='/media/icons/duotune/general/gen028.svg'
            fontIcon='bi-layers'
          >

            <AsideMenuItem
              to='/Vendors'
              icon='/media/icons/duotune/general/gen022.svg'
              title={'Vendors'}
              fontIcon='bi-app-indicator'
            />

            <AsideMenuItem
              to='/BreakfastReport'
              icon='/media/icons/duotune/ecommerce/ecm001.svg'
              title={'Manage Breakfast'}
              fontIcon='bi-app-indicator'
            />


          </AsideMenuItemWithSub>


          <div onClick={handleWeeklyWrapUpClick} className={`menu-item px-5 d-flex pt-2 `} style={{ cursor: 'pointer' }}>
            <span className='menu-icon m-2'>
              <KTSVG path={'/media/icons/duotune/calendar/calendar4.svg'} className='svg-icon-2' />
            </span>
            {'bi-app-indicator' && aside.menuIcon === 'font' &&
              <i className={clsx('bi fs-3 m-2', 'bi-app-indicator')}></i>}

            <a className={`m-2 menu-title fs-6 ${isActive ? 'text-light' : 'text-muted'}`}>

              Weekly WrapUp
            </a>
          </div>


          <div onClick={handleDocumentLibraryClick} className={`menu-item px-5 d-flex pt-2 `} style={{ cursor: 'pointer' }}>
            <span className='menu-icon m-2'>
              <KTSVG path={'/media/icons/duotune/files/fil023.svg'} className='svg-icon-2' />
            </span>
            {'bi-app-indicator' && aside.menuIcon === 'font' &&
              <i className={clsx('bi fs-3 m-2', 'bi-app-indicator')}></i>}
            <a className={`m-1 menu-title fs-6 ${isActiveDocumentLibrary ? 'text-light menu-active-bg' : 'text-muted'}`}>
              Documents Library
            </a>
          </div>



        </>
      }

      {(IsCheifEngineer || IsAdmin || IsManager || IsVPO || IsAreaDirector) && HotelId !== '0' && HotelId !== 0 &&
        <>
          <AsideMenuItem
            to='/FacilitiesInspection'
            icon='/media/icons/duotune/art/art002.svg'
            title={'Facilities Inspection'}
            fontIcon='bi-app-indicator'

          />
        </>
      }




      < div onClick={logout} className='menu-item  px-5 d-flex p-2' style={{ cursor: 'pointer' }}>
        {/* <i className="menu-icon bi bi-box-arrow-up-right m-2"></i> */}
        <i className="bi bi-arrow-up-left-circle-fill m-3 fa-lg"></i>
        <a className='m-2 menu-title fs-6 text-muted'>

          Sign Out
        </a>
      </div >


    </>
  )
}
